<template>
  <ais-pagination
    :class-names="{
      'ais-Pagination': 'flex justify-center my-5',
    }"
  >
    <template
      v-slot="{
        currentRefinement,
        nbPages,
        pages,
        isFirstPage,
        isLastPage,
        refine,
        createURL
      }"
    >
      <ul class="ais-Pagination-list">
        <li v-if="!isFirstPage" class="ais-Pagination-item ais-Pagination-item--page border rounded-l">
          <a
            :href="createURL(currentRefinement - 1)"
            @click.prevent="refine(currentRefinement - 1)"
            class="ais-Pagination-link pagination-link"
            :class="`hover:text-${color}`"
          >
            ‹
          </a>
        </li>
        <li class="ais-Pagination-item ais-Pagination-item--page border"
        :class="pages.length > 1 ? '' : 'onlyChild'">
          <a :href="createURL(0)" @click.prevent="refine(0)"
          class="ais-Pagination-link"
          :class="currentRefinement === 0
          ? `pagination-link-selected ring-${color} text-${color}` : `pagination-link hover:text-${color}`">
            1
          </a>
        </li>
        <li class="ais-Pagination-item ais-Pagination-item--page border"
          v-if="currentRefinement > 3 && nbPages > 7"
          @click.stop >
          <a
            class="ais-Pagination-link pagination-link pointer-events-none"
          >
            ...
          </a>
        </li>
        <li v-for="page in pages.slice(1, -1)" :key="page"
        class="ais-Pagination-item ais-Pagination-item--page border">
          <a
            :href="createURL(page)"
            @click.prevent="refine(page)"
            :class="currentRefinement === page
            ? `pagination-link-selected ring-${color} text-${color}` : `pagination-link hover:text-${color}`"
            class="ais-Pagination-link"
          >
            {{ page + 1 }}
          </a>
        </li>
        <li class="ais-Pagination-item ais-Pagination-item--page border hover:cursor-default
        hover:from-transparent hover:to-transparent" @click.stop
        v-if="currentRefinement < (nbPages - 4) && nbPages > 7">
          <a
            class="ais-Pagination-link pagination-link pointer-events-none"
          >
            ...
          </a>
        </li>
        <li class="ais-Pagination-item ais-Pagination-item--page border" v-show="pages.length > 1">
          <a :href="createURL(nbPages)" @click.prevent="refine(nbPages)"
          :class="currentRefinement === (nbPages - 1)
          ? `pagination-link-selected ring-${color} text-${color}` : `pagination-link hover:text-${color}`"
          class="ais-Pagination-link">
            {{ nbPages }}
          </a>
        </li>
        <li v-if="!isLastPage" class="ais-Pagination-item ais-Pagination-item--page border rounded-r">
          <a
            :href="createURL(currentRefinement + 1)"
            @click.prevent="refine(currentRefinement + 1)"
            class="ais-Pagination-link pagination-link"
            :class="`hover:text-${color}`"
          >
            ›
          </a>
        </li>
      </ul>
    </template>
  </ais-pagination>
</template>

<script>
import {
  AisPagination,
} from 'vue-instantsearch/vue3/es';

export default {
  components: {
    AisPagination,
  },
  props: {
    color: {
      type: String,
      default: 'bee2_yellow',
    },
  },
};
</script>

<style>
.pagination-link {
  @apply bg-gradient-to-l from-white to-white shadow-none rounded-none
   dark:from-lh_gray dark:to-lh_gray dark:text-gray-100 dark:hover:text-lh_gray
}

.pagination-link-selected {
  @apply shadow-md ring-1 scale-105
}

.ais-Pagination-link {
  @apply border-none
}

.ais-Pagination-link:hover {
  @apply border-none
}

.ais-Pagination-item:first-child.onlyChild > .ais-Pagination-link {
  @apply rounded
}
</style>
